// extracted by mini-css-extract-plugin
export default {"page-layout":"SectionPageEdit_page-layout__efhfF","pageLayout":"SectionPageEdit_page-layout__efhfF"};